import styled, { keyframes } from 'styled-components';

/**
 * Indicador de carregamento.
 *
 * Substitui `loading.gif` e `arrowLoading.gif`, que traziam a identidade antiga rasterizada
 * e não podiam ser recoloridos por token. Sendo CSS, acompanha a paleta automaticamente.
 *
 * `prefers-reduced-motion` interrompe a rotação: o anel permanece visível e o estado de
 * carregamento continua legível, sem movimento contínuo.
 */

const girar = keyframes`
	to { transform: rotate(360deg); }
`;

const Circulo = styled.span<{ $size: number }>`
	display: inline-block;
	width: ${(props) => props.$size}px;
	height: ${(props) => props.$size}px;
	border: ${(props) => Math.max(2, Math.round(props.$size / 10))}px solid var(--border-default);
	border-top-color: var(--action-accent-surface);
	border-radius: 50%;
	animation: ${girar} 0.9s linear infinite;

	@media (prefers-reduced-motion: reduce) {
		animation: none;
		border-top-color: var(--action-link);
	}
`;

interface IProps {
	/** Diâmetro em px. Padrão 25 — o tamanho usado nos indicadores inline. */
	size?: number;
	/** Rótulo para leitores de tela. */
	label?: string;
}

export const Spinner = ({ size = 25, label = 'Carregando' }: IProps) => (
	<Circulo $size={size} role="status" aria-label={label} />
);
